export { operationCircularize } from './circularize';
export { operationContinue } from './continue';
export { operationCopy } from './copy';
export { operationDelete } from './delete';
export { operationDisconnect } from './disconnect';
export { operationDowngrade } from './downgrade';
export { operationExtract } from './extract';
export { operationMerge } from './merge';
export { operationMove } from './move';
export { operationOrthogonalize } from './orthogonalize';
export { operationPaste } from './paste';
export { operationReflectShort, operationReflectLong } from './reflect';
export { operationReverse } from './reverse';
export { operationRotate } from './rotate';
export { operationSplit } from './split';
export { operationStraighten } from './straighten';
